module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA7ElEQVQ4T42TQQ6CMBBFO9xI6H2URBMWxru4MGokcaH38ADCCTyKpvUPoWYoA7ZJKaX9r8P8DhVF8TDGvNq2rTA69JSWQXcgIkt42UOxw+TeNM0yAZJZa2vvfYm9J8KDIWeMmwRIlud5jX0l+hUHrhnALQUyEnO0AfAPooo7UZQxLRIThy3zFANGkTjn3vKf4yRrgAGkm/QJ0xyaAkirGHBDxlepgJ+YT4bfn95iFRJHMBCzzxB7cU9GEAnQxOFqS3cGkACYEwenVQgDUsSTEKYesVrNWTV12fD9QqisJzL9RDlvEypRRsJVvPgCtXC2OydgyBAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xx.png
// module id = Dg3V
// module chunks = 15